//#region src/punchh_olo_phone_slug.ts
var PunchhOloPhoneSlug = /* @__PURE__ */ function(PunchhOloPhoneSlug) {
	PunchhOloPhoneSlug["PunchhPhoneNumber"] = "punchh-phone-number";
	PunchhOloPhoneSlug["PunchhKiosk"] = "punchh-kiosk";
	PunchhOloPhoneSlug["PunchhMsPhoneNumber"] = "punchhms-phone-number";
	PunchhOloPhoneSlug["PunchhDqUsPhoneNumber"] = "punchhdq-us-phone-number";
	return PunchhOloPhoneSlug;
}(PunchhOloPhoneSlug || {});
//#endregion
export { PunchhOloPhoneSlug };

//# sourceMappingURL=punchh_olo_phone_slug.js.map